import { put, take } from 'redux-saga/effects';

import { URGENT_VISIT_TYPE_CODE } from '../../../constants';
import * as changeStatus from '../requests/status-change-req';
import { appointmentDetailsActions } from '../appointment-details';
import * as appointmentDetails from '../../appointmnents/appointment-details-req';
import * as changeUrgentVisitStatus from '../requests/status-urgent-visit-change-req';

function* handleChangeRequest(request, payload) {
  yield put(request.actions.send(payload));
  const { payload: result } = yield take(request.consts.SUCCEED);
  return { result };
}

function* defineChangeRequestByCode({ code, ...payload }) {
  switch (code) {
    case URGENT_VISIT_TYPE_CODE:
      return yield handleChangeRequest(changeUrgentVisitStatus, payload);
    default:
      return yield handleChangeRequest(changeStatus, payload);
  }
}

export function* finishVirtualVisit({ id, event, appointment }) {
  const appointmentId = appointment.id;
  const { code } = appointment.visitType;

  const { result } = yield defineChangeRequestByCode({
    id,
    code,
    event,
    appointmentId,
  });

  yield put(appointmentDetails.actions.succeed(result));

  yield put(
    appointmentDetailsActions.sliceUpcomingAppointment({
      ...result,
      userId: id,
    }),
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/finish-virtual-visit-saga.js